import { createListFilters, IOption } from '../../../../../components'

export type PacientesFilters = {
  /** Nome do paciente (busca parcial). */
  paciente: string
  empresa?: IOption<number>
  situacao?: IOption<boolean>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<PacientesFilters>({
  paciente: '',
  empresa: undefined,
  situacao: undefined,
})
